<nav class="navbar">
  <img class="navbar-brand logo" src="assets/img/app-logo.svg" alt="App Logo" />
  <form class="form-inline mr-5">
    <app-dropdown
      [items]="languages"
      [selectedItem]="languageSelected"
      [class]="'btn-no-lines'"
      (onEmit)="changeSelectLang($event)"
    >
    </app-dropdown>
  </form>
</nav>

<div
  class="signin-wrapper loginContain justify-content-center align-items-center"
>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-8 col-lg-5">
        <form [formGroup]="formdata" name="formdata" #ngForm="ngForm">
          <h1 class="mb-4">
            {{ translationKeys.Authorization.ForgotYourPasswordQuestion | translate }}
        </h1>
          <p class="forgetDesc">
            {{
              translationKeys.Authorization
                .InputUserNameToSendPasswordRestoreCredentials | translate
            }}  
          </p>

          <div >
            <div class="form-group">
              <label class="input-floating mb-40 mb-2">
                <input
                  class="form-input"
                  inputSanitizer
                  type="text" 
                  id="inputName"
                  maxlength="100"
                  formControlName="inputName"
                  placeholder="{{
                    translationKeys.Authorization.UsernamePlaceholder
                      | translate
                  }}"
                  required
                  autofocus
                  [ngClass]="{
                    'invalidForm':
                      (formdata.get('inputName').errors &&
                        (formdata.get('inputName').touched ||
                          formdata.get('inputName').dirty)) ||
                      ngForm.submitted
                  }"
                />
                <span> 
                  {{ 'AUTHORIZATION.USERNAME_OR_EMAIL' | translate }}
                </span>
                
              </label> 
            </div>
          </div>
          <div class="row">
            <div
              class="col my-3 justify-content-between align-items-center d-flex"
            >
              <button
                (click)="cancelModal()"
                class="btn btn-continue-bordered-bd col-5"
              >
                {{ translationKeys.Authorization.Cancel | translate }}
              </button>
              <button
                (click)="onSubmit(formdata.value)"
                class="btn btn-bd col-5"
              >
                {{ translationKeys.Authorization.Send | translate }}
              </button>
            </div>
          </div>
        </form>
        <div class="mt-5 disclaimer">
          {{
            "AUTHORIZATION.USAGE_REQUIRES_REGISTRATION_BY_INSTITUTION_ADMIN"
              | translate
          }}
          asd
        </div>
      </div>
    </div>
  </div>
</div> 

<app-toast></app-toast>
